import React, { CSSProperties, FC } from 'react';
import classNames from 'classnames';
import classes from './styles/index.module.scss';
import { formatEmptyListNode } from '../../../../../../ReactSharedScripts/modules/list';

type SpreadsheetBodyRowItemProps = {
	width?: string;
	className?: string;
	style?: CSSProperties;
	hasAvatar?: boolean;
	importless?: boolean;
	isTruncated?: boolean;
	hasTinyVrPadding?: boolean;
	hasScantyVrPadding?: boolean;
	onClick?: () => void;
};

export const SpreadsheetBodyRowItem: FC<React.PropsWithChildren<SpreadsheetBodyRowItemProps>> = ({
	width,
	children,
	className,
	style,
	hasAvatar,
	importless,
	isTruncated,
	hasTinyVrPadding,
	hasScantyVrPadding,
	onClick,
}) => {
	const componentClasses = classNames(classes.bodyRowItem, className, {
		[classes.item_hasAvatar]: hasAvatar,
		[classes.bodyRowItem_truncated]: isTruncated,
		[classes.bodyRowItem_importless]: importless,
		[classes.bodyRowItem_hasTinyVrPadding]: hasTinyVrPadding,
		[classes.bodyRowItem_hasScantyVrPadding]: hasScantyVrPadding,
	});
	const styles = {
		...style,
		width,
	};

	return (
		<div
			className={componentClasses}
			style={styles}
			onClick={onClick}
		>
			{formatEmptyListNode(children)}
		</div>
	);
};
